module.exports = __webpack_public_path__ + "static/media/folders.8a74ac34.svg";